import { Box, Flex, Image, useBreakpointValue } from '@chakra-ui/react';
import { Text, VStack } from 'components/ui';
import { ReviewCard } from '../ui/ReviewCard';
import { ContactSupport } from './ContactSupport';

const highFiveImg = './../celebrate-phase3-completion.png';

export const TestimonialWithContactSupportCard = () => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  return (
    <Box pr={isMobile ? undefined : '80px'} alignSelf={'center'}>
      <VStack
        alignItems={'center'}
        flexWrap={'wrap'}
        justifyContent={'center'}
        //@ts-ignore
        gap={6}
      >
        <Image
          alt={'two people high-fiving'}
          objectFit="contain"
          w={'300px'}
          boxSize={'300px'}
          maxW={'500px'}
          src={highFiveImg}
        />

        <Flex
          direction="column"
          gap="24px"
          align="center"
          overflow="auto"
          pb={3}
          px={2}
          mt={-32}
        >
          <ReviewCard
            content={
              <Text fontWeight={'normal'} fontSize={'md'}>
                “My original goal was{' '}
                <b>
                  to have a normal BM every day and I got there thanks to Ayble
                </b>{' '}
                — it’s like clockwork now! <br />
                <br /> After many challenging and lonely years,{' '}
                <b>I felt so heard and supported by my Ayble care team.</b> They
                were awesome!”
              </Text>
            }
            name={'Carol Z., Constipation'}
            numStars={5}
            width={isMobile ? '100%' : undefined}
          />
        </Flex>
      </VStack>

      <VStack alignItems="center" pt={4} pb={isMobile ? 8 : undefined}>
        <ContactSupport />
      </VStack>
    </Box>
  );
};
